import { Box, IconButton, Tooltip } from "@mui/material";
import Iconify from "../../minimals/components/iconify";
import { ReactNode, useState } from "react";

type PrefilledIndicatorProps = {
  color?: "inherit" | "primary" | "default" | "secondary" | "error" | "info" | "success" | "warning" | undefined;
  title: ReactNode;
  content?: string;
  sx?: object;
  open?: boolean;
  onClose?: () => void;
  placement?:
    | "bottom"
    | "left"
    | "right"
    | "top"
    | "bottom-end"
    | "bottom-start"
    | "left-end"
    | "left-start"
    | "right-end"
    | "right-start"
    | "top-end"
    | "top-start"
    | undefined;
};

const PrefilledIndicator = ({ color = "primary", title, sx, open, onClose, placement }: PrefilledIndicatorProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const tooltipContent = onClose ? (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: -1, mt: -0.5, mr: -1 }}>
        <IconButton size="small" onClick={onClose} sx={{ color: "inherit", p: 0.25 }}>
          <Iconify icon="eva:close-fill" width={16} />
        </IconButton>
      </Box>
      {title}
    </Box>
  ) : (
    title
  );

  const isOpen = open !== undefined ? open || isHovered : undefined;

  return (
    <Tooltip
      title={tooltipContent}
      sx={{ position: "absolute", right: 6, top: 32, ...sx }}
      open={isOpen}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            whiteSpace: "pre-line",
            maxWidth: 700,
            p: 1.5
          }
        },
        popper: {
          modifiers: [
            {
              name: "flip",
              enabled: false
            }
          ]
        }
      }}
    >
      <IconButton color={color} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <Iconify icon={"eva:alert-circle-fill"} />
      </IconButton>
    </Tooltip>
  );
};

export default PrefilledIndicator;
